export const ManagersListingKey = 'cc_managers';
export const ContractControlKey = 'contract_control';